/**
 * Central place for brand asset URLs so every screen and print stays in sync.
 */
export const BRAND_LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_ayurveda-care-27/artifacts/hi17r931_image-removebg-preview.png";

// NABH badge shown next to the logo. Currently a text badge until the
// official PNG is uploaded — swap NABH_LOGO_URL with the asset URL when
// available.
export const NABH_LOGO_URL = null;
